var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountDeletedIcon = function SvgAccountDeletedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#FEF2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.584 87.584s-4.53-6.04-12.08-6.04c-7.551 0-12.081 6.04-12.081 6.04m21.14-21.141h.031m-18.151 0h.03m39.232 9.06c0 16.68-13.522 30.201-30.202 30.201s-30.201-13.521-30.201-30.2c0-16.68 13.522-30.202 30.201-30.202 16.68 0 30.202 13.521 30.202 30.201Zm-19.631-9.06a1.51 1.51 0 1 1-3.02 0 1.51 1.51 0 0 1 3.02 0Zm-18.121 0a1.51 1.51 0 1 1-3.02 0 1.51 1.51 0 0 1 3.02 0Z",
    stroke: "#EF4444",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAccountDeletedIcon;